import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PageTracker = () => {
  const location = useLocation();
  const prevPath = useRef("");

  useEffect(() => {
    // Skip admin pages
    if (location.pathname.startsWith("/admin")) return;

    const referrer = prevPath.current;
    prevPath.current = location.pathname;

    // Fire and forget — don't block rendering
    fetch(`${BACKEND_URL}/api/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        page: location.pathname,
        referrer: referrer,
      }),
    }).catch(() => {});
  }, [location.pathname]);

  return null;
};

export default PageTracker;
